module.exports = __webpack_public_path__ + "img/credential-text-digital-marketing.01a808379264b37fb6b0fa3354c8329d.svg";